<template>
    <div class="c-fill-height">
        <v-container fluid grid-list-xl class="c-container c-container__light">
            <h5 class="headline c-mb-4">Empfänger Info</h5>

            <v-layout row wrap fill-height>
                <v-flex sm12 md4>
                    <div class="subheading c-mb-2">Profilbild</div>
                    <v-img max-width="250px" width="100%" :src="require('../../assets/avatar.jpg')"></v-img>
                </v-flex>

                <v-flex sm12 md8>
                    <v-form class="c-form" ref="form" v-model="valid" lazy-validation>
                        <v-text-field
                                v-model="recipient.name"
                                label="Name"
                                required
                                class="c-mb-5">
                        </v-text-field>

                        <v-text-field
                                v-model="recipient.location"
                                label="Adresse"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="recipient.responsible"
                                label="Kontaktperson in der Institution"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="recipient.contactPhone"
                                label="Kontaktnummer"
                                required
                        ></v-text-field>

                        <div style="font-size: 16px; color: rgba(0,0,0,0.54); margin-bottom: 0.5rem;">Gerät</div>
                        <div style="font-size: 16px; color: rgba(0,0,0,0.87); ">{{currentDeviceName}}</div>
                        <div style="font-size: 14px; color: rgba(0,0,0,0.54); ">{{currentDeviceId}}</div>

                    </v-form>
                </v-flex>
            </v-layout>
        </v-container>
        <div class="c-form-footer">
            <v-spacer></v-spacer>
            <v-btn large class="shrink" flat>
                Abbrechen
            </v-btn>
            <v-btn large class="shrink" color="secondary">
                Speichern
            </v-btn>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapState} = createNamespacedHelpers('device')

export default {
  name: 'VoiceMessageRecipient',
  data () {
    return {
      editMode: false,
      valid: false,
      recipient: {
        name: 'Frida Hess',
        location: 'Frauenfeld Altersheim 3rd floor, 304',
        responsible: 'Kristina',
        contactPhone: '(123) 444-4444'
      }
    }
  },
  computed: {
    ...mapState({
      currentDeviceName: state => state.currentDevice.environment.label,
      currentDeviceId: state => state.currentDevice.device,
    })
  },
  created () {},
  methods: {}
}
</script>
